module.exports = __webpack_public_path__ + "static/media/axis_of_polarization_00170.45edf0d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/hdpolarized/axis/en/axis_of_polarization_00170.png
// module id = 900
// module chunks = 0